import { createGlobalStyle } from "styled-components";
const normalize = `
  /*! modern-normalize | MIT License | https://github.com/sindresorhus/modern-normalize */html{box-sizing:border-box}*,::after,::before{box-sizing:inherit}:root{-moz-tab-size:4;tab-size:4}html{line-height:1.15;-webkit-text-size-adjust:100%}body{margin:0}body{font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol'}hr{height:0}abbr[title]{text-decoration:underline dotted}b,strong{font-weight:bolder}code,kbd,pre,samp{font-family:SFMono-Regular,Consolas,'Liberation Mono',Menlo,Courier,monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;line-height:1.15;margin:0}button,select{text-transform:none}[type=button],[type=reset],[type=submit],button{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:1px dotted ButtonText}fieldset{padding:.35em .75em .625em}legend{padding:0}progress{vertical-align:baseline}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}
`;

const GlobalStyles = createGlobalStyle`
  ${normalize};
  @import url("https://fonts.googleapis.com/icon?family=Material+Icons");

  html {
    ${"" /* change this if implementing light/dark mode functionality */}
    &::-webkit-scrollbar {
      width: 5px;
    }
    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px #cccccc;
      border-radius: 10px;
    }
    &::-webkit-scrollbar-thumb {
      background: #aaaaaa;
      border-radius: 10px;
    }
  }

  h1, h2, h3, h4 {
    font-family: "Bebas Neue", "Helvetica", "Arial", sans-serif;
  }
  
  h5, h6, body {
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  }
  h4{
    font-weight: 300;
  }
  h6{
    font-weight: 100;
  }
  h6{
    letter-spacing: 5px;
  }
  h1, h2, h3, h4, h5{
    margin:0;
    text-align: left;
  }

  h1 {
    ${props => props.theme.fontSize.jumbo};
  }
  h2 {
    ${props => props.theme.fontSize.larger};
  }
  h3 {
    ${props => props.theme.fontSize.larger};
  }

  h4 {
    ${props => props.theme.fontSize.small};
  }
  h5 {
    ${props => props.theme.fontSize.xsmall};
  }
  p {
    ${props => props.theme.fontSize.xxsmall};
    text-align: left;
    padding: 0;
    margin: 0;
  }
  li {
    all:unset;
  }

  @media (max-width: ${props => props.theme.screen.md}) {
    h1 {
      ${props => props.theme.fontSize.xlarge};
    }
    h2 {
      ${props => props.theme.fontSize.large};
    } 
  }
  @media (max-width: ${props => props.theme.screen.sm}) {
    h1 {
      ${props => props.theme.fontSize.large};
    }
    h3 {
      ${props => props.theme.fontSize.regular};
    }
    h4 {
      ${props => props.theme.fontSize.xsmall};
    }
    
    .courseModal {
      width:95%;
      
    }
  }
  @media (max-width: ${props => props.theme.screen.xs}) {
    h1 {
      ${props => props.theme.fontSize.medium};
    }
    h2 {
      ${props => props.theme.fontSize.regular};
    } 
    h4 {
      ${props => props.theme.fontSize.xsmall};
    }
    button {
      ${props => props.theme.fontSize.xxxsmall};
    }
  }
  @media (max-width: ${props => props.theme.screen.xxs}) {
    h2 {
      ${props => props.theme.fontSize.regular};
    }
    h5 {
      ${props => props.theme.fontSize.xxxsmall};
    }  
  }

  a, a:visited {
    cursor: pointer;
    color: white;
    transition: 0.3s;
  }
  a:hover {
    color: #faed25;
  }

  a, u {
    text-decoration: none;
  }
  .courseModal {
    padding:0!important;
    max-width:1000px!important;
    width:100%;
    border-radius: 16px;
    > div {
        height: auto;
      }
  }
`;

export default GlobalStyles;
